import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { getTokenInfo } from '../../../UseToken';
import { reqGET } from '../../../Utils';
import { Link } from 'react-router-dom';
import Hosts from '../../../Hosts';
import Loader from '../../Loader/Loader';
import { language } from './Language';

import { api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {
    const [lang, set_lang] = useState('pt');
    const [dados, set_dados] = useState(data_interface);
    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);
    const [userAdmin, setUserAdmin] = useState([]);
    const [allResponsaveis, setAllResponsaveis] = useState([]);
    const [is_edit, set_is_edit] = useState(false);
    const [show_delete_button, set_show_delete_button] = useState(false);

    const handleRowClick = (id) => {
        document.getElementById('c_' + id)?.click();
    };

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);

    const fetch_administradores = async () => {
        try {
            const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Administrador`);
            setUserAdmin(res.data);
            //console.log('Administradores', res)

        } catch (error) {
            console.error("Erro ao buscar os Administradores:", error);
        }
    };

    const fetch_responsaveis = async () => {
        try {
            let res_entidade = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`);
            let result = [];

            if (res_entidade.data !== undefined) {
                result = res_entidade.data.filter(el => el.entity_type === "1");
            }

            setAllResponsaveis(result);
            //console.log('Responsáveis', result)

        } catch (error) {
            console.error("Erro ao buscar as Entidades:", error);
            return [];
        }
    };

    useEffect(() => {
        fetch_administradores();
        fetch_responsaveis();
    }, []);

    const fetch_id_info = async (id_serch) => {
        return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
            .then(res => {
                set_dados(dados.current = res.data[0]);
                //PERSON_RESPONSABLE com responsáveis profil em 'Administrador'
                let aux_responsaveis = []
                if (res.data[0].info.person_responsable !== undefined && res.data[0].info.person_responsable.length > 0) {
                    res.data[0].info.person_responsable.forEach(responsaveis => {
                        aux_responsaveis.push(responsaveis)
                    })
                }
            })
            .catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
    }

    const clean_data = () => {
        // DEEP COPY OF data_interface 
        set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
        set_dados(dados.current.info.companycode = getTokenInfo().companycode)
        //console.log(dados.current)
    }

    useEffect(() => {
        clean_data();
        set_lang(localStorage.getItem('lang'))

        try {
            let test = props.location.state.operation;

            if (test === 'edit') {
                //set_disabled(true)

                set_is_edit(true)

                set_show_delete_button(true)

                fetch_id_info(props.location.state.item['id']).then(() => {
                    setLoading(false)
                })
                return
            }
            else {

                clean_data()

                setLoading(false);

                setRedirect(false);

            }

        } catch {
            clean_data()

            setLoading(false);

            setRedirect(false);
            return
        }

        return () => {
            clean_data()
        }

    }, [props])

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <Loader />
            :
            <div className={`dash-cards header`}>
                <div >
                    <h2 className="dash-title" >{language[lang].category}</h2>
                    <p className='mb-3' >{language[lang].category} / {dados.id !== '' ? language[lang].category_view : language[lang].category_view}</p>
                </div>

                <div className={`dash-cards body`} >
                    <div className="card mb-5 mb-xl-10 ">
                        <div className="card-header border-0 cursor-pointer" >
                            <div className="card-body">
                                {/* Entidades Patronais */}
                                {userAdmin.length > 0 && (
                                    <div className="row mb-4">
                                        <label className="fs-5 fw-bold mb-2">
                                            {language[lang].entidade_p}
                                        </label>
                                        <div className={"div-table"}>
                                            <div className='table-body interlocutores-list table-responsive'>
                                                <table className="table interlocutores-list table-hover table-bordered align-middle">
                                                    <thead className="text-center align-middle">
                                                        <tr>
                                                            <th className='p-3'>{language[lang].name}</th>
                                                            <th className='p-3'>{language[lang].contact}</th>
                                                            <th className='p-3'>{language[lang].email}</th>
                                                            <th className='p-3'></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userAdmin
                                                            .filter(user => user.entity_type === "1")
                                                            .map((user, index) => (
                                                                <tr
                                                                    key={index}
                                                                    onClick={() => handleRowClick(user.id)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <td className="d-flex align-items-center">
                                                                        {/* Avatar */}
                                                                        <div
                                                                            className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center me-2"
                                                                            style={{
                                                                                width: "35px",
                                                                                height: "35px",
                                                                                fontWeight: "bold",
                                                                                fontSize: "0.8rem",
                                                                                backgroundColor: user.foto ? "transparent" : "#6c757d",
                                                                                overflow: "hidden"
                                                                            }}
                                                                        >
                                                                            {(() => {
                                                                                let fotoUrl = null;
                                                                                if (user.foto) {
                                                                                    try {
                                                                                        const parsed = JSON.parse(user.foto);
                                                                                        if (Array.isArray(parsed) && parsed.length > 0) {
                                                                                            fotoUrl = parsed[0].link || (parsed[0].path + parsed[0].name);
                                                                                        }
                                                                                    } catch (e) {
                                                                                        console.warn("Invalid foto JSON for user", user.name, e);
                                                                                    }
                                                                                }

                                                                                return fotoUrl ? (
                                                                                    <img
                                                                                        src={fotoUrl}
                                                                                        alt={user.name}
                                                                                        className="img-fluid rounded-circle"
                                                                                        style={{ width: "35px", height: "35px", objectFit: "cover" }}
                                                                                    />
                                                                                ) : (
                                                                                    user.name
                                                                                        ?.split(" ")
                                                                                        .map(word => word[0]?.toUpperCase())
                                                                                        .join("")
                                                                                        .substring(0, 2)
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                        <span className="text-truncate" title={user.name}>
                                                                            {user.name}
                                                                        </span>
                                                                    </td>
                                                                    <td>{user.mobile_phone}</td>
                                                                    <td>{user.email}</td>

                                                                    <td>
                                                                        <Link
                                                                            id={"c_" + user.id}
                                                                            className="d-none"
                                                                            to={{
                                                                                pathname: "entidade_interna_view",
                                                                                state: { item: user, operation: "view" },
                                                                            }}
                                                                            replace
                                                                        >
                                                                            <i className="bi bi-eye"></i>
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Entidades de Departamento */}
                                {allResponsaveis.length > 0 && (
                                    <div className="row mb-4">
                                        <label className="fs-5 fw-bold mb-2">
                                            {language[lang].entidade} {language[lang].of} {dados?.info?.name || '—'}
                                        </label>
                                        <div className={"div-table"}>
                                            <div className='table-body interlocutores-list table-responsive'>
                                                <table className="table interlocutores-list table-hover table-bordered align-middle">
                                                    <thead className="text-center align-middle">
                                                        <tr>
                                                            <th className='p-3'>{language[lang].name}</th>
                                                            <th className='p-3'>{language[lang].contact}</th>
                                                            <th className='p-3'>{language[lang].email}</th>
                                                            <th className='p-3'></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {allResponsaveis
                                                            .filter(resp =>
                                                                Array.isArray(resp.departamento) &&
                                                                resp.departamento.some(dep => dep?.name === dados?.info?.name)
                                                            )
                                                            .map((resp, index) => (
                                                                <tr
                                                                    key={index}
                                                                    onClick={() => handleRowClick(resp.id)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <td className="d-flex align-items-center">
                                                                        <div
                                                                            className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2"
                                                                            style={{
                                                                                width: "35px",
                                                                                height: "35px",
                                                                                fontWeight: "bold",
                                                                                fontSize: "0.8rem",
                                                                                backgroundColor: resp.foto ? "transparent" : "#0d6efd",
                                                                                overflow: "hidden"
                                                                            }}
                                                                        >
                                                                            {(() => {
                                                                                let fotoUrl = null;
                                                                                if (resp.foto) {
                                                                                    try {
                                                                                        const parsed = JSON.parse(resp.foto);
                                                                                        if (Array.isArray(parsed) && parsed.length > 0) {
                                                                                            fotoUrl = parsed[0].link || (parsed[0].path + parsed[0].name);
                                                                                        }
                                                                                    } catch (e) {
                                                                                        console.warn("Invalid foto JSON for resp", resp.name, e);
                                                                                    }
                                                                                }

                                                                                return fotoUrl ? (
                                                                                    <img
                                                                                        src={fotoUrl}
                                                                                        alt={resp.name}
                                                                                        className="img-fluid rounded-circle"
                                                                                        style={{ width: "35px", height: "35px", objectFit: "cover" }}
                                                                                    />
                                                                                ) : (
                                                                                    resp.name
                                                                                        ?.split(" ")
                                                                                        .map(word => word[0]?.toUpperCase())
                                                                                        .join("")
                                                                                        .substring(0, 2)
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                        <span className="text-truncate" title={resp.name}>
                                                                            {resp.name}
                                                                        </span>
                                                                    </td>
                                                                    <td>{resp.mobile_phone}</td>
                                                                    <td>{resp.email}</td>

                                                                    <td>
                                                                        <Link
                                                                            id={"c_" + resp.id}
                                                                            className="d-none"
                                                                            to={{
                                                                                pathname: "entidade_view",
                                                                                state: { item: resp, operation: "view" },
                                                                            }}
                                                                            replace
                                                                        >
                                                                            <i className="bi bi-eye"></i>
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
}